var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusRejected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65169 7.65169C8.35496 6.94842 8.75005 5.99459 8.75005 5.00002C8.75005 4.00546 8.35496 3.05162 7.65169 2.34836C6.94842 1.64509 5.99459 1.25 5.00002 1.25C4.00546 1.25 3.05162 1.64509 2.34836 2.34836M7.65169 7.65169C6.94842 8.35496 5.99459 8.75005 5.00002 8.75005C4.00546 8.75005 3.05162 8.35496 2.34836 7.65169C1.64509 6.94842 1.25 5.99459 1.25 5.00002C1.25 4.00546 1.64509 3.05162 2.34836 2.34836M7.65169 7.65169L2.34836 2.34836",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusRejected);
export default __webpack_public_path__ + "static/media/status_rejected.23ae3b5645673bdd8e671f447073b496.svg";
export { ForwardRef as ReactComponent };